import { useCallback, useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import type { AppliedRangeFilters } from '~/validations/AppliedFilters';

type OwnArgs = {
  allowSingleValues?: boolean;
  eventName: string;
  filterKey: keyof AppliedRangeFilters;
  max: number | undefined;
  min: number | undefined;
};

export default function useRangeUpdater({
  allowSingleValues = true,
  eventName,
  filterKey,
  max: rangeMax,
  min: rangeMin
}: OwnArgs): (range: number[] | undefined) => void {
  const { updateRangeFilter } = useContext(AppliedFiltersContext);
  const trackEvent = useTrackEvent();

  return useCallback(
    (range: number[] = []) => {
      const min = range.at(0);
      const max = range.at(1);

      const value: { max?: number; min?: number } =
        min === rangeMin && max === rangeMax ? {} : { min, max };
      if (allowSingleValues && min === rangeMin) delete value.min;
      if (allowSingleValues && max === rangeMax) delete value.max;

      updateRangeFilter({ filterKey, value });
      trackEvent(eventName, { min, max });
    },
    [
      allowSingleValues,
      eventName,
      filterKey,
      rangeMax,
      rangeMin,
      trackEvent,
      updateRangeFilter
    ]
  );
}
